import { combineReducers } from "redux";

// import reducer
import userDetails from "./userDetails";

export default combineReducers({
    userDetails,
});
